module.exports = __webpack_public_path__ + "static/Tulsa-c963599e8d24a08af9359fd1330e10bd.jpg";